<div
  class="call-signal"
  [class.call-signal--good]="!current.reconnecting && current.level === 'good'"
  [class.call-signal--fair]="!current.reconnecting && current.level === 'fair'"
  [class.call-signal--poor]="current.reconnecting || current.level === 'poor'"
  [matTooltip]="label"
  role="status"
  aria-live="polite"
  [attr.aria-label]="label"
>
  <span class="call-signal__bars" aria-hidden="true">
    <span *ngFor="let bar of bars" class="call-signal__bar call-signal__bar--{{ bar }}" [class.call-signal__bar--lit]="bar <= litBars"></span>
  </span>
  <span class="call-signal__text" *ngIf="!compact && current.reconnecting">Reconnecting…</span>
  <span class="call-signal__text" *ngIf="!compact && unstable">Unstable connection — the patient may hear you breaking up.</span>
</div>
